import React from 'react';

const percentageIconStyles = {
  discountText: {
    position: 'absolute',
    top: 'calc(50% - 5px)',
    left: '0',
    width: '100%',
    transform: 'translate(0px, -50%)',
    color: '#ffffff',
    textTransform: 'uppercase',
    fontSize: '20px',
    margin: '0',
    textAlign: 'center',
    lineHeight: '120%'
  } as React.CSSProperties,
  discountAmount: {
    fontSize: '22px',
    fontWeight: 'bold',
    marginLeft: '0',
    textAlign: 'center'
  } as React.CSSProperties,
  off: {
    fontSize: '16px',
    marginLeft: '0'
  } as React.CSSProperties,
  bodyIcon: {
    position: 'absolute',
    right: '-40px',
    bottom: '-30px'
  } as React.CSSProperties
};

export interface PercentageIconProps {
  amount: number;
}

export const PercentageIcon: React.FC<PercentageIconProps> = ({ amount }) => {
  return (
    <div style={percentageIconStyles.bodyIcon} data-testid="percentage-discount-icon">
      <svg
        width="120"
        height="120"
        viewBox="0 0 146 145"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M53.1237 69.3862C55.6035 68.6638 57.0282 66.068 56.3058 63.5883C55.5835 61.1085 52.9877 59.6839 50.5079 60.4062C48.0282 61.1285 46.6035 63.7243 47.3259 66.2041C48.0482 68.6838 50.644 70.1085 53.1237 69.3862Z"
            fill="#FF4949"
          />
          <path
            d="M86.9569 79.3013C89.4367 78.5789 90.8614 75.9831 90.139 73.5034C89.4167 71.0236 86.8209 69.5989 84.3411 70.3213C81.8614 71.0436 80.4367 73.6394 81.159 76.1192C81.8814 78.5989 84.4772 80.0236 86.9569 79.3013Z"
            fill="#FF4949"
          />
          <path
            d="M121.746 60.8581L119.47 59.1096C117.004 57.2014 116.005 53.9348 117.025 50.9632L117.956 48.2566C119.377 44.1178 116.863 39.6687 112.56 38.7493L109.761 38.156C106.709 37.5167 104.398 34.9905 104.038 31.8717L103.712 29.0299C103.211 24.6869 98.992 21.7612 94.7369 22.8097L91.9536 23.501C88.9218 24.2409 85.7348 22.9725 84.0586 20.3329L82.5189 17.9161C80.1727 14.2061 75.1176 13.4102 71.7312 16.2114L69.5142 18.0271C67.1092 20.0171 63.6906 20.2488 61.0338 18.5872L58.6107 17.0725C54.9051 14.7613 50.0033 16.213 48.1597 20.2122L46.9576 22.8069C45.637 25.6509 42.6636 27.3289 39.557 26.9922L36.6961 26.6794C32.3324 26.2075 28.5651 29.6687 28.6223 34.0455L28.6717 36.9202C28.7257 40.0563 26.7752 42.869 23.8268 43.895L21.1204 44.8504C16.9871 46.3171 15.0781 51.0756 17.0538 54.989L18.3486 57.5487C19.7579 60.3378 19.2148 63.7194 17.0188 65.935L15.0108 67.9764C11.9314 71.094 12.2726 76.1999 15.7471 78.8649L18.0233 80.6135C20.4893 82.5216 21.4886 85.7883 20.4679 88.7599L19.5372 91.4665C18.1162 95.6052 20.63 100.054 24.9331 100.974L27.7324 101.567C30.7839 102.206 33.0956 104.733 33.4549 107.851L33.7813 110.693C34.2823 115.036 38.5013 117.962 42.7564 116.913L45.5397 116.222C48.5715 115.482 51.7585 116.751 53.4347 119.39L54.9744 121.807C57.3206 125.517 62.3756 126.313 65.7621 123.512L67.9791 121.696C70.3841 119.706 73.8027 119.474 76.4595 121.136L78.8826 122.651C82.6102 124.955 87.512 123.504 89.3336 119.511L90.5357 116.916C91.8562 114.072 94.8297 112.394 97.9363 112.731L100.797 113.044C105.161 113.516 108.928 110.054 108.871 105.678L108.822 102.803C108.768 99.6667 110.718 96.8541 113.667 95.8281L116.373 94.8726C120.506 93.406 122.415 88.6475 120.44 84.734L119.145 82.1743C117.735 79.3853 118.278 76.0036 120.474 73.788L122.482 71.7466C125.568 68.651 125.227 63.5452 121.746 60.8581ZM40.965 68.0569C39.2212 62.0703 42.6528 55.8176 48.6395 54.0738C54.6262 52.3299 60.8788 55.7616 62.6226 61.7483C64.3665 67.7349 60.9348 73.9875 54.9482 75.7314C48.9615 77.4753 42.7025 74.0216 40.965 68.0569ZM62.0206 92.2239C61.4232 93.6157 59.7953 94.257 58.4036 93.6596C57.0118 93.0621 56.3705 91.4343 56.9679 90.0425L75.413 47.5404C76.0105 46.1486 77.6383 45.5073 79.0301 46.1047C80.4219 46.7022 81.0632 48.33 80.4658 49.7218L62.0206 92.2239ZM88.8034 85.6401C82.8167 87.3839 76.5641 83.9523 74.8202 77.9656C73.0764 71.979 76.508 65.7263 82.4947 63.9825C88.4813 62.2386 94.734 65.6703 96.4778 71.6569C98.2217 77.6436 94.79 83.8962 88.8034 85.6401Z"
            fill="#FF4949"
          />
          <path
            d="M111.721 57.3435C118.633 81.0727 105 105.912 81.2708 112.824C57.5416 119.736 32.702 106.104 25.7899 82.3744C18.8778 58.6453 32.5107 33.8057 56.2399 26.8936C79.969 19.9815 104.809 33.6144 111.721 57.3435Z"
            fill="#FF4949"
          />
          <path
            d="M89.7572 120.157L90.9746 117.558C92.307 114.739 95.2818 113.059 98.4034 113.416L101.247 113.742C105.595 114.239 109.398 110.826 109.369 106.426L109.346 103.564C109.313 100.447 111.282 97.6454 114.251 96.623L116.955 95.6923C121.089 94.2679 123.037 89.5179 121.097 85.5884L119.823 83.0192C118.447 80.2179 119 76.8325 121.216 74.6272L123.245 72.6032C126.363 69.5132 126.051 64.4054 122.587 61.7015L120.336 59.9276C117.875 58.0075 116.913 54.719 117.963 51.7667L118.921 49.0743C120.38 44.9579 117.533 39.1638 113.231 38.2246L108.616 38.0011L31.5 103.5C32.8739 105.231 33.5609 108 33.5609 111.087C34.0397 115.45 38.9549 118.233 43.2167 117.235L46.0134 116.568C49.0643 115.84 52.231 117.139 53.8678 119.797L55.3836 122.234C57.7059 125.955 62.7638 126.794 66.16 124.022L68.3809 122.207C70.801 120.23 74.2203 120.032 76.8567 121.699L79.2827 123.221C82.9701 125.568 87.8827 124.135 89.7572 120.157Z"
            fill="#FF2323"
          />
        </g>
      </svg>
      <p style={percentageIconStyles.discountText}>
        <span style={percentageIconStyles.discountAmount}>
          {parseFloat(amount.toFixed(2))}%<br />
        </span>
        <span style={percentageIconStyles.off}>off</span>
      </p>
    </div>
  );
};
